import {
  INBOX_FILTER,
  INBOX_FILTER_SUCCESS,
  INBOX_FILTER_ERROR,
  INBOX_SEGMENTS,
  INBOX_SEGMENTS_SUCCESS,
  INBOX_SEGMENTS_ERROR,
} from "./actionTypes"

const initialState = {
  responseFilter: null,
  loadingFilter: false,
  errorFilter: "",
  responseSegments: null,
  loadingSegments: false,
  errorSegments: "",
}

const Inbox = (state = initialState, action) => {
  switch (action.type) {
    case INBOX_FILTER:
      state = {
        ...state,
        responseFilter: null,
        loadingFilter: true,
        errorFilter: "",
        responseSegments: null,
      }
      break
    case INBOX_FILTER_SUCCESS:
      state = {
        ...state,
        loadingFilter: false,
        responseFilter: action.payload.data
      }
      break
    case INBOX_FILTER_ERROR:
      state = {
        ...state,
        loadingFilter: false,
        errorFilter: action.payload
      }
      break
    case INBOX_SEGMENTS:
      state = {
        ...state,
        responseSegments: null,
        loadingSegments: true,
        errorSegments: "",
      }
      break
    case INBOX_SEGMENTS_SUCCESS:
      state = {
        ...state,
        loadingSegments: false,
        responseSegments: action.payload.data
      }
      break
    case INBOX_SEGMENTS_ERROR:
      state = {
        ...state,
        loadingSegments: false,
        errorSegments: action.payload
      }
      break
    default:
      state = {...state}
      break
  }
  return state
}

export default Inbox
